import React, { useId } from "react";

// Labelled form field for the post studios. The label names the control; hint and error text are
// linked with aria-describedby so they don't become part of the control's accessible name.
const StudioField = ({ label, hint, hintTone, error, wide = false, action, children }) => {
  const generatedId = useId();
  const control = React.Children.only(children);
  const inputId = control.props.id || generatedId;
  const hintId = hint ? `${inputId}-hint` : null;
  const errorId = error ? `${inputId}-error` : null;
  const describedBy = [hintId, errorId].filter(Boolean).join(" ") || undefined;

  return <div className={`studio-field${wide ? " is-wide" : ""}${error ? " has-error" : ""}`}>
    <span className="studio-field-label"><label htmlFor={inputId}>{label}</label>{action}</span>
    {React.cloneElement(control, { id: inputId, ...(typeof control.type === "string" ? { "aria-describedby": describedBy, "aria-invalid": error ? true : undefined } : {}) })}
    {hint && <small id={hintId} className={`studio-field-hint${hintTone ? ` is-${hintTone}` : ""}`}>{hint}</small>}
    {error && <small id={errorId} className="studio-field-error" role="alert">{error}</small>}
  </div>;
};

export default StudioField;
